/**
 * @file Re-exports the page that manages an organization's integration settings.
 */
import OrganizationIntegration from "./OrganizationIntegration";

export default OrganizationIntegration;
